import { render, staticRenderFns } from "./CategoryConfiguratorChapters.vue?vue&type=template&id=0f8b1ba0&"
import script from "./CategoryConfiguratorChapters.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports